// src/hooks/useMetrikaHit.ts
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { hitPage } from '@store/metric/metric-operations';
import { getPageSlug } from '@configs/metrics/ROUTE_SLUGS';
import type { AppDispatch } from '@store/store';
import {
  extractUtmFromSearch,
  getCurrentPageUtm,
  mergeUtmParams,
  readUtmParamsFromSearch,
} from '@utils/utmTracking';

export function useMetrikaHit() {
  const { pathname, search, hash } = useLocation();

  // ✅ задаём начальное значение, чтобы не падал TS
  const prevRef = useRef<string | undefined>(undefined);

  // ✅ типизируем под thunk-и
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const { cleanedSearch } = extractUtmFromSearch(search);
    const normalizedSearch = cleanedSearch ? `?${cleanedSearch}` : '';
    const url = pathname + normalizedSearch + hash;
    if (prevRef.current === url) return; // защита от дублей в одном монтировании

    const referer = prevRef.current ?? (document.referrer || undefined);

    const utmParamsFromUrl = readUtmParamsFromSearch(search);
    const utmParams = mergeUtmParams(utmParamsFromUrl, getCurrentPageUtm());
    const params = { source: getPageSlug(pathname), ...utmParams };

    dispatch(hitPage({ url, title: document.title, referer, params }));

    prevRef.current = url;
  }, [pathname, search, hash, dispatch]);
}
